import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Card, Row, Col, Select } from 'antd';
import { PdfViewer } from '../../../shared/custom-ant-d'
import BookList from './_BookList'
import { reqGetRetrieveEmployeeHandbooks } from '../../../axios/api'

export const EmpHandbook = () => {
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  }
  const query = useQuery();
  const Auth = useSelector(state => state.Auth);
  const LookUpData = useSelector(state => state.LookUpData);

  const [listLoading, setListLoading] = useState(false);
  const [employeeHandbooks, setEmployeeHandbooks] = useState(null);
  const [selectedHandbook, setSelectedHandbook] = useState(null);
  const [countryCode, setCountryCode] = useState(null);

  useEffect(() => {
    if (countryCode != null) {
      setListLoading(true);
      reqGetRetrieveEmployeeHandbooks(countryCode)
        .then(res => {
          if (res.data.isSuccess) {
            setEmployeeHandbooks(res.data.employeeHandbooks);
            if (res.data.employeeHandbooks.length == 1) {
              setSelectedHandbook(res.data.employeeHandbooks[0]);
            }
          }
          setListLoading(false);
        })
        .catch(err => {
          console.log(err);
        });
    }
  }, [countryCode]);

  useEffect(() => {
    if (query.get('countryCode') != null) {
      setCountryCode(query.get('countryCode'))
    }
    else if (query.get('countryCode') == null && Auth.candidateID > 0 && LookUpData != null) {
      let CountryCode = LookUpData.countryList.filter(i => i.countryID == Auth.countryID)[0].countryCode;
      setCountryCode(CountryCode)
    }
  }, [query.get('countryCode'), Auth, LookUpData]);

  return (
    <Card className="documents-card iqor-header"
      title={
        <Row>
          <Col
            md={4}
            xs={{ span: 24 }}
          >Employee Handbook</Col>
          <Col
            md={{ span: 2, offset: 1 }}
            xs={{ span: 7 }}>
            <span style={{ fontSize: 'small' }}>Select Country:</span>

          </Col>
          <Col
            md={{ span: 2 }}
            xs={{ span: 6 }}>
            &nbsp;&nbsp;&nbsp;
            <Select
              value={countryCode}
              style={{ width: '100%' }}
              onChange={(val) => {
                setCountryCode(val)
                setSelectedHandbook(null)
              }}
            >
              {
                LookUpData && (
                  LookUpData.countryList.map((item, i) => {
                    return (
                      <Select.Option value={item.countryCode} key={i}>{item.countryCode}</Select.Option>
                    );
                  })
                )
              }
            </Select>
          </Col>
        </Row>
      } >
      <BookList
        employeeHandbooks={employeeHandbooks}
        listLoading={listLoading}
        setSelectedHandbook={setSelectedHandbook}
      />
      {
        (selectedHandbook != null) ?
          (
            <PdfViewer
              useUrl={`${selectedHandbook.fileName}`}
            // blobcontainer={selectedHandbook.azureContainerName}
            // filename={selectedHandbook.fileName}
            />
          ) : (<></>)
      }
    </Card>
  )
}
